import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { AuthProvider, LoginPage, useAuth } from "./auth";
import { AppShell } from "./components";
import { AgendaPage } from "./pages/AgendaPage";
import { NewAppointmentPage } from "./pages/NewAppointmentPage";
import { CustomersPage } from "./pages/CustomersPage";
import { NewCustomerPage } from "./pages/NewCustomerPage";
import { DashboardPage } from "./pages/DashboardPage";
import { FinancePage } from "./pages/FinancePage";
import { NewFinanceEntryPage } from "./pages/NewFinanceEntryPage";
import { WorkOrderDetailPage } from "./pages/WorkOrderDetailPage";
import { FiscalSharePage } from "./pages/FiscalSharePage";
import { WorkOrdersPage } from "./pages/WorkOrdersPage";
import { PeoplePage } from "./pages/PeoplePage";
import { InventoryPage } from "./pages/InventoryPage";
import { AdministrationPage } from "./pages/AdministrationPage";
import { CustomerDetailPage } from "./pages/CustomerDetailPage";
import { CommercialPage, NewQuotePage } from "./pages/CommercialPage";
import { ServicesPage } from "./pages/ServicesPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { SecuritySettingsPage, SettingsPage } from "./pages/SecuritySettingsPage";
import { PwaInstallPrompt } from "./PwaInstallPrompt";
import { MoneyVisibilityProvider } from "./money-visibility";
import { PasskeyEnrollmentPrompt } from "./PasskeyEnrollmentPrompt";
import { MobileSessionLock, StoredSessionLock } from "./app-lock";
import { PushNotificationPrompt } from "./PushNotificationPrompt";
import { AgentPage } from "./pages/AgentPage";
import { AgentOverlay } from "./AgentOverlay";

function AuthenticatedApplication() {
  return <MoneyVisibilityProvider><Routes>
    <Route element={<AppShell />}>
      <Route index element={<DashboardPage />} />
      <Route path="agenda" element={<AgendaPage />} />
      <Route path="agenda/novo" element={<NewAppointmentPage />} />
      <Route path="clientes" element={<CustomersPage />} />
      <Route path="clientes/novo" element={<NewCustomerPage />} />
      <Route path="clientes/:customerId" element={<CustomerDetailPage />} />
      <Route path="ordens" element={<WorkOrdersPage />} />
      <Route path="ordens/:workOrderId" element={<WorkOrderDetailPage />} />
      <Route path="ordens/:workOrderId/nota-fiscal/enviar" element={<FiscalSharePage />} />
      <Route path="financeiro" element={<FinancePage />} />
      <Route path="financeiro/novo" element={<NewFinanceEntryPage />} />
      <Route path="equipe" element={<PeoplePage />} />
      <Route path="estoque" element={<InventoryPage />} />
      <Route path="servicos" element={<ServicesPage />} />
      <Route path="administracao" element={<AdministrationPage />} />
      <Route path="configuracoes" element={<SettingsPage />} />
      <Route path="configuracoes/seguranca" element={<SecuritySettingsPage />} />
      <Route path="notificacoes" element={<NotificationsPage />} />
      <Route path="orcamentos" element={<CommercialPage />} />
      <Route path="orcamentos/novo" element={<NewQuotePage />} />
      <Route path="assistente" element={<AgentPage />} />
      <Route path="comercial" element={<Navigate to="/orcamentos" replace />} />
      <Route path="comercial/novo" element={<Navigate to="/orcamentos/novo" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes><AgentOverlay /><PasskeyEnrollmentPrompt /><PushNotificationPrompt /></MoneyVisibilityProvider>;
}

function ProtectedRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <main className="boot">
    <div className="boot-loader" role="status" aria-live="polite">
      <LoaderCircle className="spin" size={30} aria-hidden="true" />
      <strong>Carregando…</strong>
    </div>
  </main>;
  if (!user) return <><StoredSessionLock><LoginPage /></StoredSessionLock><PwaInstallPrompt authSurface /></>;
  return <><MobileSessionLock user={user}><AuthenticatedApplication /></MobileSessionLock><PwaInstallPrompt /></>;
}

export function App() {
  return <BrowserRouter><AuthProvider><ProtectedRoutes /></AuthProvider></BrowserRouter>;
}
